import { render, staticRenderFns } from "./VendorReviewsFilter.vue?vue&type=template&id=35489028&scoped=true"
import script from "./VendorReviewsFilter.vue?vue&type=script&lang=js"
export * from "./VendorReviewsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35489028",
  null
  
)

export default component.exports